<template>
  <div class="original-documents">
    <section v-if="data.data.attachments && data.data.attachments.length">
      <div class="project-info__inner-sections">
        <documents-list :documents="data.data.attachments"
                        :ocr-documents="data.data.ocrAttachments"
                        mode="with-icon" />
        <button v-if="showDownloadAllButton"
                class="sk-btn sk-btn--white original-documents__download-all-btn"
                :disabled="zipRequested"
                @click="emailOrderFilesZip">{{ $pgettext('translation', 'Download all files') }}</button>
      </div>
      <div v-if="data.data.countOfWords"
           class="project-info__inner-sections">
        <data-section :data="sectionData" />
      </div>
      <template v-if="showPriceToCustomer">
        <div class="project-info__price">
          <strong>Total Price</strong>
          <strong>{{ data.data.demanderQuoteAmount }} NOK</strong>
        </div>
      </template>
    </section>
    <section v-else-if="displayShowFilesButton">
      <router-link :to="verificationLink"
                   class="sk-btn sk-btn--white">{{ $gettextInterpolate('Show files') }}</router-link>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import DocumentsList from '@/components/assignment_components/one_assignment/DocumentsList';
  import DataSection from '@/components/assignment_components/one_assignment/assignment_info/DataSection';
  import EmailAttachmentsZipMixin from '@/mixins/EmailAttachmentsZipMixin';

  export default {
    components: {
      'documents-list': DocumentsList,
      'data-section': DataSection,
    },
    mixins: [EmailAttachmentsZipMixin],
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        showPriceToCustomer: false,
      };
    },
    computed: {
      ...mapGetters('FeatureFlagsStore', ['enableSecureWorkflow']),
      ...mapGetters('OneProjectStore', ['project', 'isHighSecurityProject']),
      ...mapGetters('UserInfoStore', ['userIsNotInterpreter', 'identityVerificationCreated', 'isShared']),
      sectionData() {
        return {
          data: [{
            data: this.data.data?.countOfWords || 0,
            title: this.$pgettext('translation', 'Total Words')
          }]
        };
      },
      // Downloading many files one by one is a pain, so customers get them all zipped by email
      showDownloadAllButton() { return this.userIsNotInterpreter && this.data.data.attachments.length > 1; },
      displayShowFilesButton() { return this.isHighSecurityProject && this.userIsNotInterpreter && this.data.data?.initialAttachmentsPresent && this.enableSecureWorkflow; },
      verificationLink() { return this.$makeRoute({name: 'VerificationBuyer', query: {redirectUrl: this.$route.fullPath, view: this.identityVerificationCreated ? 'signIn' : 'verification', orderId: this.project.id}}); },
    },
    methods: {
      emailOrderFilesZip() {
        this.emailAttachmentsZip(() => this.$fetcher.emailOrderAttachmentsZip(this.project.id));
      }
    }
  };
</script>

<style scoped>
.project-info__section-title {
  margin: 5px;
  color: #000;
  font-size: 18px;
  line-height: 14px;
}

.project-info__inner-sections {
  position: relative;
}

.original-documents__download-all-btn {
  width: auto;
  margin-top: 15px;
  padding: 0 15px;
}

.project-info__inner-sections:first-child {
  padding-bottom: 20px;
}

.project-info__price {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 20px;
}
</style>
